<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="titlepage">
<div class="ipadfp"><span aria-label="page i" epub:type="pagebreak" id="page_i" role="doc-pagebreak"><img alt="Cold Cases: A True Crime Collection, by Cheyna Roth, Ulysses Press" class="imagefp" src="e9781646041145/images/title.jpg"/></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6fcef806